import { createFileRoute } from "@tanstack/react-router";
import { ExperienceDeepLink } from "@/components/ExperienceDeepLink";
import bannerPoster from "@/assets/banner-poster.webp.asset.json";

const URL = "https://www.travelbackland.com/couples";
const TITLE = "Romantic Getaways in Arizona — Backland";
const DESC =
  "A romantic getaway under Arizona's dark skies — luxury tented suites, private hot tubs, and on-site dining on 160 acres surrounded by national forest.";

export const Route = createFileRoute("/couples")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "preload", as: "image", href: bannerPoster.url, fetchPriority: "high", type: "image/webp" } as any,
    ],
  }),
  component: () => <ExperienceDeepLink slug="couples" />,
});
